import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptors } from "../../app/store/baseQueryWithReauth";
import { reducerPathEnums } from "../../shared/types/common-types";
import type { LessonType } from "./types";

export const lessonApi = createApi({
	reducerPath: reducerPathEnums.Lesson,
	tagTypes: ["Lesson"],
	baseQuery: baseQueryWithInterceptors,
	endpoints: (builder) => ({
		getLessons: builder.query<LessonType[], string>({
			query: () => "lessons",
			providesTags: (result, error: unknown) => {
				if (result)
					return result.map(({ _id }) => ({ type: "Lesson", id: _id }));
				if (error) return [{ type: "Lesson" }];
				return [{ type: "Lesson" }];
			},
		}),
		getLessonById: builder.query<LessonType, string>({
			query: (id = "") => `lessons/${id}`,
			providesTags: (result, error: unknown, id) => {
				if (result) {
					return [{ type: "Lesson", id: result?._id }];
				}

				if (error) {
					return [{ type: "Lesson", id }];
				}

				return [{ type: "Lesson", id }];
			},
		}),
	}),
});

export const {
	useGetLessonsQuery,
	useGetLessonByIdQuery,
	useLazyGetLessonsQuery,
} = lessonApi;
